import { gql } from '@zenbusiness/application-commons-graphql';

// Define query get customer token
export const GET_CUSTOMER_TOKEN = gql`
  query customerToken($params: CustomerTokenInput!) {
    customerToken(params: $params) {
      token
      expiresIn
    }
  }
`;
